// Represents a binary expression operator to be used between two non-boolean values
// ex: int = int, int > int, int != int, so on
// note: InPeriod are hard coded ranges from the current date. Last 1 day, Last 7 days,  Last 30 Days, Month to Date, Year to Date, Next 7 Days, Next 30 Days, Next 60 Days
export enum FieldValueOperatorEnum {
  Equals,
  Contains,
  NotEqual,
  GreaterThan,
  LessThan,
  InPeriod,
  Between,
  DaysForward,
  DaysBack,
  DoesNotcontain,
  StartsWith,
  LessThanOrEqual,
  GreaterThanOrEqual,
}
